export default __webpack_public_path__ + "static/media/DT NEXT.6a67db0a.svg";